import { useState } from 'react';
import { GraduationCap } from 'lucide-react';

/**
 * Instructor avatar tile — shows the instructor's profile photo when
 * available, otherwise falls back to the graduation-cap icon. Reused
 * on `/instructors`, `/instructors/<state>`, `/instructors/<city>` so
 * the directory feels human, not generic.
 *
 * If the photo URL is set but the image fails to load (404 / dead S3
 * link), we silently fall back to the icon so the card never shows a
 * broken-image glyph.
 *
 * Sizing: `sizePx` is the outer square in pixels (default 56, matching
 * the existing `w-14 h-14` card tile).
 */
export function InstructorAvatar({ photoUrl, name, sizePx = 56, testId }) {
  const [broken, setBroken] = useState(false);
  const style = { width: sizePx, height: sizePx };
  const iconPx = Math.max(16, Math.round(sizePx / 2));
  const showPhoto = !!photoUrl && !broken;

  if (showPhoto) {
    return (
      <img
        src={photoUrl}
        alt={name ? `${name}'s profile photo` : 'Instructor profile photo'}
        className="rounded-xl object-cover flex-shrink-0 bg-slate-100"
        style={style}
        loading="lazy"
        onError={() => setBroken(true)}
        data-testid={testId}
      />
    );
  }
  return (
    <div
      className="rounded-xl bg-[#b456df]/10 flex items-center justify-center flex-shrink-0"
      style={style}
      data-testid={testId}
    >
      <GraduationCap style={{ width: iconPx, height: iconPx }} className="text-[#b456df]" />
    </div>
  );
}
